export enum CATEGORIES {
  LANDING_PAGE = "Landing Page",
  NEW_SHIPPER_LANDING = "New Shipper",
  LOGIN = "Login",
  MOBILE_MENU = "Mobile Menu",
  PROFILE = "Profile",
  REGISTER = "Register",
  SHIPPERS = "Shippers",
}

export enum ACTIONS {
  BACK_BUTTON = "Back Button",
  CANCEL = "Cancel",
  DECLINE_SHIPPER = "Decline Shipper",
  ENROLL_SHIPPER = "Enroll Shipper",
  FILTER_BUTTON = "Filter Button",
  FINNISH_CLOUD_REGISTER = "Finnish Cloud Register",
  GOOGLE_LOGIN = "Google Login",
  INVITE_LINK = "Link de Invitacion",
  LOGIN = "Login",
  LOGIN_SUCCESS = "Login Success.",
  LOGOUT = "Logout",
  REGISTER = "Register",
  SAVE = "Save",
  SWITCH_TAB = "Switch Tab",
  VIEW_PROFILE = "Ver Perfil",
  WHATSAPP = "Whatsapp",
  APP_DOWNLOAD = "Download Shipper App",
  SEARCHING_BY_TEXT = "Searching By Text",
}

export enum LABELS {
  CLOUD_DATA = "Datos Nube",
  ENROLL_SHIPPER_MODAL = "Enroll Shipper Modal",
  PERSONAL_DATA = "Datos Personales",
  UPDATE_PROFILE_DATA = "Update Profile Data",
  IOS = "IOS",
  ANDROID = "ANDROID",
}

export type GaEvent = {
  category: CATEGORIES;
  action: ACTIONS;
  label?: LABELS;
};
